import auditService from "../../services/auditService";
import * as types from "./types";
import { initialState } from "./initialState";

const service = new auditService();

export const getAuditList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.FETCH_AUDIT_ROWS,
      payload: { ...initialState, loader: true },
    });
    
    service
      .getAuditData(data)
      .then((res) => {
        dispatch({
          type: types.FETCH_AUDIT_ROWS,
          payload: { data: res.data.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.FETCH_AUDIT_ROWS,
          payload: {
            ...initialState,
            msg: "error",
            loader: false,
            next: false,
          },
        });
      });
  };
};

